import Card from '../card'
import styled from '@emotion/styled'
import border from '_utils/css-border'
import { css } from '@emotion/core'
import { mobile, pablet } from '_utils/responsive-queries'
import { themeIsDark } from '_colorBus/primitives/scheme'
export const CardStyled = styled(Card)`
  display: flex;
  align-items: center;
  margin: 20px 0;
  .grow {
    flex-grow: 1;
  }

  .info {
    display: flex;
    flex-direction: column;
  }

  ${pablet} {
    padding: 25px 15px;
  }
`

export const Avatar = styled.div`
  ${border()}
  width: 75px;
  height: 75px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  margin: 25px;
  flex-shrink: 0;
  background-color: ${({ theme }) =>
    themeIsDark(theme.colors) ? 'var(--shade)' : 'var(--background)'};

  ${pablet} {
    align-self: flex-start;
    margin: 0 25px 0 0;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 80%;
  margin-bottom: 25px;
  .company-name {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
    padding-top: 30px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  .location {
    font-size: 14px;
    font-weight: 400;
    opacity: 0.6;
  }
  .description {
    margin-top: 10px;
  }

  ${pablet} {
    margin-bottom: 0;
    .company-name {
      padding: 0;
    }
  }

  ${mobile} {
    .title {
    }
    .location {
      padding: 0;
    }
    .description {
    }
  }
`

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  min-height: 75px;
  ${pablet} {
    flex-direction: column;
    margin: 0;
  }
`

export const ExpandButtonWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  button {
    padding: 30px 20px;
    border: none;
    background-color: transparent;
    font-size: 12px;
    font-weight: 500;
    span {
      font-size: 14px;
      font-weight: 500;
    }
    &:hover {
      opacity: 0.6;
    }
  }

  ${pablet} {
    button {
      padding: 0;
      i {
        color: var(--flavor-contrast);
      }
    }
  }

  ${mobile} {
    button {
      padding: 0;
    }
  }
  ${({ isMobileView }) =>
    isMobileView &&
    css`
      flex-direction: row;
      justify-content: center;
      transform: translateX(-50px);
      margin-top: 25px;
      button {
        width: 23px;
        height: 23px;
        border-radius: 50%;
        background-color: var(--flavor);
        i {
          color: var(--flavor-contrast);
        }
      }
    `}
`
